window.addEventListener('load', () => {
    const comment_form = document.querySelector('#comment-form');

    comment_form && comment_form.addEventListener('submit', e => {
        e.preventDefault();
        const url = '/wp-json/add/comment';
        add_comment(url, comment_form);
    });

    document.addEventListener('click', e => {
        if ( !e.target.closest('.reply-btn') ) return;
        const closest_element = e.target.closest('.reply-btn'),
            reply_form = closest_element.nextElementSibling,
            post_id = reply_form.dataset.post_id,
            comment_id = reply_form.dataset.comment_id;
        let html = `
					<input type="hidden" name="post_id" id="postId" value="${ post_id }"/>
					<input type="hidden" name="comment_id" value="${ comment_id }"/>
					<div>
						<label for="name">Name*</label>
						<input id="name" name="name" type="text" required/>
					</div>
					<div>
						<label for="email">Email*</label>
						<input id="email" name="email" type="email" required/>
					</div>
					<div>
						<label for="comment">Comment*</label>
						<textarea name="comment" id="comment" cols="30" rows="10" required></textarea>
					</div>
					<input type="submit" value="Reply"/>
                    `;
        reply_form.insertAdjacentHTML('beforeend', html);
        reply_form.classList.toggle('active');
        reply_form.addEventListener('submit', e => {
            e.preventDefault();
            const url = '/wp-json/add/reply';
            add_comment(url, reply_form);
        });
    });
});

function create_form_data(form_elements) {
    // Make form data object and populate it with all inputs from form
    let data = new FormData();
    Array.from(form_elements).forEach(el => {
        if ( el.name ) {
            data.append(el.name, el.value);
        }
    });
    return data;
}

function add_comment(url, form) {
    const data = create_form_data(form.elements),
        notice_output = form.querySelector('.form-notice'),
        submit_btn = form.querySelector('[type="submit"]');

    // Start animating submit btn
    submit_btn && submit_btn.classList.add('loading');

    fetch(url, {
        method: 'post',
        body: data,
    })
        .then(response => response.json())
        .then(json => {
            notice_output.innerHTML = `<p>${ json }</p>`;

            // Stop animating submit btn
            submit_btn && submit_btn.classList.remove('loading');

            // Empty values after submitting comment
            Array.from(form.elements).forEach(el => el.value = '');
        })
        .catch(error => {
            submit_btn && submit_btn.classList.remove('loading');
            console.error('REST API error:', error);
        });
}



// WEBPACK FOOTER //
// ./scripts/modules/rest-comment.js